var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#85949F",
    stroke: "#85949F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.27 1h8.54v8.54H5.27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#85949F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.27 5.27H1v8.53h8.54V9.54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicate-icon.165cf70b92ea2de180ebb08edfddf53e.svg";
export { ForwardRef as ReactComponent };